import { flexPos } from '@/assets/styles/mixin';
import { FC, ReactNode } from 'react';
import { styled } from 'styled-components';

const TipsFlagWrap = styled.div<{ $show: boolean }>`
  height: 84rem;
  background-color: #ebebeb;
  color: #979797;
  text-align: center;
  font-size: 24rem;
  ${flexPos('center')}
  display: ${(props) => (props.$show ? 'flex' : 'none')};
`;

export const TipsFlag: FC<{ children: ReactNode; show: boolean }> = ({ children, show }) => {
  return <TipsFlagWrap $show={show}>{children}</TipsFlagWrap>;
};
